import { Divider } from "@mui/material";
import { useMassUpdateBOMWizardStore } from "csi/store/MassUpdateWizardStore";
import CheckboxTree from "designSystem/components/checkbox/CheckboxTree";
import RadioGroup from "designSystem/components/radio/RadioGroup";
import { Checkbox, GridColumn, SearchPlaceholder, SearchTextField, Text } from "designSystem/index";
import { observer } from "mobx-react-lite";
import React, { FunctionComponent } from "react";

export const MassUpdateSettingsForm: FunctionComponent = observer(() => {
	const MASS_UPDATE_SHARED_DATA_SHEETS = "MassUpdateSharedDataSheets";
	const store = useMassUpdateBOMWizardStore();
	const { disableCreateRevision, createRevision, searchedItems, pushAllOption, overrideAttributes, uniqueIds, onUpdateOption, onUpdateAttributeSettings, onCreateRevision, onSearchTextChange, 
		placementSettingsLabel, attributeSettingsLabel, attributesSettingsOptions, massUpdateOptions, searchText, selectSectionTitleRes, treeStore } = store;

	const handleChange = (event: object, value: boolean) => {
		onCreateRevision(value);
	};
	return (
		<GridColumn scroll spacing={4}>
			<Text res="MassUpdateSettings" variant="h6" />
			<RadioGroup
				name={placementSettingsLabel}
				onChange={onUpdateOption}
				options={massUpdateOptions}
				value={pushAllOption}
			/>
			{Array.isArray(attributesSettingsOptions) && !!attributesSettingsOptions.length &&
				(
					<RadioGroup
						name={attributeSettingsLabel}
						onChange={onUpdateAttributeSettings}
						options={attributesSettingsOptions}
						value={overrideAttributes}
					/>
				)}
			<Checkbox
				checked = {createRevision}
				disabled = {disableCreateRevision}
				labelProps={{
					res: "CreateNewRevision",
				}}
				onChange={handleChange}
			/>
			<Divider />
			<Text res={selectSectionTitleRes} variant="h6" />
			<SearchTextField
				fullWidth
				onChange={onSearchTextChange}
				placeholderRes="Search"
				value={searchText}
			/>
			{searchedItems.length > 0 ? (
				<CheckboxTree
					defaultExpanded={uniqueIds}
					displayCounts
					store={treeStore}
				/>
			) : (
				<SearchPlaceholder 
					titleProps={{ res: "SEARCH_NO_RESULTS" }}
				/>
			)}
		</GridColumn>
	);
});

export default MassUpdateSettingsForm;
